import { Http } from '@/lib/http';

export class DueDiligenceService extends Http {
  constructor() {
    super();
  }

  fetchDueDiligenceTypes() {
    return this.httpClient().get('onboarder/settings/due-diligence-types');
  }

  updateDueDiligenceType(update) {
    return this.httpClient().patch(
      'onboarder/settings/due-diligence-types/' + update.id,
      update
    );
  }

  fetchDueDiligenceGuides() {
    return this.httpClient().get('onboarder/settings/due-diligence-guides');
  }

  updateDiligenceGuide(update) {
    return this.httpClient().patch(
      'onboarder/settings/due-diligence-guides/' + update.id,
      update
    );
  }
}
